import omit from 'lodash/omit';
import uniq from 'lodash/uniq';
import without from 'lodash/without';

import * as types from './types';

const initialState: types.Modals = {
  byKeyId: {},
  keys: [],
};

function modals(state = initialState, action: types.ModalAction): types.Modals {
  switch (action.type) {
    case types.ADD_MODAL: {
      const { type, props } = action.payload;
      const uniqueId = type;

      return {
        byKeyId: {
          ...state.byKeyId,
          [uniqueId]: {
            type,
            props,
          },
        },
        keys: uniq([...state.keys, uniqueId]),
      };
    }
    case types.DELETE_MODAL:
      return {
        byKeyId: omit(state.byKeyId, action.payload.modalId),
        keys: without(state.keys, action.payload.modalId),
      };
    default:
      return state;
  }
}

export default modals;
